import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import './App.css'

// Pages Components
import About from './Pages/About/About';
import WhyCallistus from './Pages/WhyCallistus/WhyCallistus';
import Presence from './Pages/Presence/Presence';
import PhotosGallery from './Pages/PhotosGallery/PhotosGallery';
import VideosGallery from './Pages/VideosGallery/VideosGallery';
import Products from './Pages/Products/Products';
import SpecialSolutions from './Pages/SpecialSolution/SpecialSolutions';
import Inspiration from './Pages/Inspiration/Inspiration';
import Contact from './Pages/Contact/Contact';
import Home from './Pages/Home/Home';
import Career from './Pages/Carrer/Career';
import Jobs from './Pages/Carrer/Jobs';
import Trade from './Pages/Trade/Tade';
import OperatingSystems from './Pages/OperatingSystems/OperatingSystems';
import LCP from './Pages/LightControlPrivacy/LCP';
import Innovation from './Pages/Innovation/Innovation';
import TermsConditions from './Pages/TermsConditions/TermsConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import EnergyEfficiency from './Pages/EnergyEfficiency/EnergyEfficiency';
import FabricShade from './Pages/FabricShade/FabricShade';
import Blogs from './Pages/Blogs/Blogs';
import News from './Pages/News/News';
import FAQ from './Pages/FAQ/FAQ';
import Automation from './Pages/Automation/Automation';
import ChildSafety from './Pages/ChildSafety/ChildSafety';
import PrintedBlinds from './Pages/PrintedBlinds/PrintedBlinds';
import FilterInspiration from './Pages/FilterInspiration/FilterInspiration';
import FilterFabricContent from './Pages/ProductsSubPage/FilterFabric/FilterFabricContent';


//import Blog Post UI
import BlogPost_UI from './Pages/Blogs/BlogsPageUI/BlogsPageUI'

//import Product page UI
import ProductPageUI from './Pages/ProductsSubPage/ProductPageUI/ProductPageUI'

//import News Post UI
import NewsPost_UI from './Pages/News/NewsPost_UI/NewsPost_UI';

//import Video Page UI
import VideoPage_UI from './Pages/VideosGallery/VideoPageUI/VideoPageUI';

//import Job From UI

import JobApplyForm_UI from './Pages/Carrer/PageComponent/JobApplyForm_UI'

//import Product OS UI

import Product_OS_UI from './Pages/OperatingSystems/Product_OS_UI/Product_OS_UI';


function App() {
  return (
    <Router>

      <ScrollToTop />

      <Routes>

        {/* Define URL For Websites Pages */}

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/WhyCallistus" element={<WhyCallistus />} />
        <Route path="/presence" element={<Presence />} />
        <Route path="/photos-gallery" element={<PhotosGallery />} />
        <Route path="/videos-gallery" element={<VideosGallery />} />
        <Route path="/products" element={<Products />} />
        <Route path="/Trade" element={<Trade />} />
        <Route path="/special-solutions" element={<SpecialSolutions />} />
        <Route path="/inspiration" element={<Inspiration />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career/jobs" element={<Jobs />} />
        <Route path="/operating-systems" element={<OperatingSystems />} />
        <Route path="/light-control-privacy" element={<LCP />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/energy-efficiency" element={<EnergyEfficiency />} />
        <Route path="/fabric-shade" element={<FabricShade />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/news" element={<News />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/filter-inspiration" element={<FilterInspiration />} />
        <Route path="/child-safety" element={<ChildSafety />} />


        {/* URL for different products UI */}

        <Route path="/printed-blinds" element={<PrintedBlinds />} />
        <Route path="/automation" element={<Automation />} />


        {/* Dynamic URL for Products pages */}

        <Route path="/products/:productId" element={<ProductPageUI />} />


        {/* Dynamic URL for Products Fabric pages */}

        <Route path="/products/:productId/:ProductFabricId" element={<FilterFabricContent />} />


        {/* Dynamic URL for Blog Posts */}

        <Route path="/blog/:Blog_Posts" element={<BlogPost_UI />} />

        {/* Dynamic URl for News Post Page  */}

        <Route path="/news/:News_Post_Id" element={<NewsPost_UI />} />


        {/* Dynamic URl for News Post Page  */}

        <Route path="/videos/:Video_PageID" element={<VideoPage_UI />} />

        {/* Dynamic URl for News Post Page  */}

        <Route path="/job/:JobPagesID" element={<JobApplyForm_UI />} />


        {/* Dynamic URl for Product OS Pages  */}

        <Route path="/:ProductOS_PG_ID" element={<Product_OS_UI />} />

        {/* Fallback URL If Page Not Found */}

        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </Router>
  );
}

export default App;
